<template lang="pug">
v-layout(column)
  v-btn(@click="() => $router.back()" color="primary" x-large block).mb-4.mt-2 zurück
  span.overflownt
    span.display-1 Datenschutzerkl&auml;rung
    br
    span.subtitle-1 Stand 01.01.2020
    br
    h1 Einleitung
    br
    | Um Ihnen ein sicheres Gef&uuml;hl bei der Nutzung unserer Dienste zu vermitteln, haben wir zahlreiche organisatorische und technische Ma&szlig;nahmen ergriffen. Die vorliegende Datenschutzerkl&auml;rung soll Sie zum einen &uuml;ber die Art der verarbeiteten Daten, deren Verarbeitung und deren Schutz informieren und zum anderen &uuml;ber den Zweck der Datenverarbeitung aufkl&auml;ren. Das wichtigste wollen wir bereits an dieser Stelle f&uuml;r Sie zusammenfassen.
    br
    | Beim Besuch unserer Webseite, ohne die Nutzung unserer Dienste, werden keine pers&ouml;nlichen Daten von uns erfasst.
    br
    | F&uuml;r die Erbringung unseres Dienstleistungsangebotes ist es notwendig, pers&ouml;nliche Daten von Ihnen zu erheben. Hierbei unterliegen wir der Datenschutzgrundverordnung (DSGVO) der Europ&auml;ischen Union (EU) und handeln nach folgenden Grunds&auml;tzen:
    br
    br
    | Es werden von uns nur Daten erfasst und verarbeitet, die Sie freiwillig an uns &uuml;bermitteln und die zur Vertragserf&uuml;llung notwendig sind (Rechtm&auml;&szlig;igkeit).
    br
    | Es werden nur solche Daten erhoben, die aus rechtlichen Gr&uuml;nden f&uuml;r uns vorgeschrieben und f&uuml;r die Erbringung der jeweiligen Leistung erforderlich sind (Datenminimierung).
    br
    | Die erfassten Daten werden f&uuml;r den daf&uuml;r vorgesehenen Zweck verwendet (Zweckbindung).
    br
    | und nach Ende der Notwendigkeit vollst&auml;ndig entfernt (Speicherbegrenzung).
    br
    | Als Nutzer unserer Dienste haben Sie zu jeder Zeit das Recht auf Auskunft &uuml;ber die von uns &uuml;ber Sie erfassten Daten (Auskunftspflicht).
    br
    | Wir tragen h&ouml;chste Sorgfalt bei dem Schutz Ihrer Daten. Sowohl vor unbefugtem Zugriff als auch vor unbeabsichtigtem Verlust (Integrit&auml;t und Vertraulichkeit).
    br
    | Die Richtigkeit und Konsistenz Ihrer Daten wird durch technische Mittel unterst&uuml;tzt, Korrekturen werden unverz&uuml;glich vorgenommen und Daten im Zweifelsfall gel&ouml;scht (Richtigkeit).
    br
    | Weitere Informationen zur DSGVO und was dies f&uuml;r Sie bedeutet erhalten Sie auf unserer DSGVO Seite speziell zur neuen Verordnung der EU. Dar&uuml;ber hinaus erfahren Sie auf dieser Seite mehr &uuml;ber unsere Datenverarbeitung, Ihre Rechte und was wir tun, um Ihre Privatsph&auml;re zu sch&uuml;tzen.
    br
    | Bei der Nutzung unserer Dienstleistung stimmen Sie unserer Datenschutzerkl&auml;rung zu und gestatten es uns zweckgebunden Daten zu erheben.
    br
    | Gem&auml;&szlig; Art. 6 Abs. 1 lit. b+f verarbeiten wir Daten f&uuml;r die Ausf&uuml;hrung/Bereitstellung unserer Dienstleistung. Sie k&ouml;nnen einer Verarbeitung Ihrer Daten jederzeit und ohne Angabe von Gr&uuml;nden widersprechen. Dazu gen&uuml;gt eine formlose E-Mail an db@eberswalde.fitness.
    br
    | Eine &Uuml;bermittlung Ihrer erfassten Daten an Dritte erfolgt in keiner Weise.
    br
    | Hinweis zur verantwortlichen Stelle
    br
    | FitnessStudio Colosseum GmbH
    br
    | Bergerstr. 9
    br
    | 16225 Eberswalde
    br
    | db@eberswalde.fitness
    br
    br
    | Die verantwortliche Stelle ist die nat&uuml;rliche oder juristische Person, die allein oder gemeinsam mit anderen &uuml;ber den Rahmen und die Mittel der Verarbeitung personenbezogener Daten entscheidet. Dazu z&auml;hlen sowohl technische als auch organisatorische Ma&szlig;nahmen zur Sicherung des Datenschutzes.
    br
    | Welche Daten werden von uns verarbeitet
    br
    | Bei der Nutzung unseres Dienstes werden einige personenbezogene Daten von uns erfasst. Dies geschieht, um Ihnen die Nutzung zu erm&ouml;glichen und so angenehm wie m&ouml;glich zu gestalten. Welche Daten im Detail von uns verarbeitet werden ist vom Verwendungszweck unserer Dienste abh&auml;ngig und wird im Folgenden genauer erl&auml;utert.
    br
    h1 Allgemeine Informationen
    br
    | Beim Besuch unserer Webseite und der Nutzung unserer Dienste werden von Ihrem Ger&auml;t automatisch Informationen an uns &uuml;bermittelt und in sogenannten Server Access Logs gespeichert. Dabei handelt es sich um folgende Informationen:
    br
    | IP Adresse des Endger&auml;tes
    br
    | Webseite &uuml;ber die Sie zu uns gelangt sind (Referrer)
    br
    | Verwendeter Browser inklusive der Browserversion
    br
    | Betriebssystem des Endger&auml;tes
    br
    | Uhrzeit des Besuchs
    br
    h1 Registrierung
    br
    | Bei der Registrierung f&uuml;r unseren Dienst werden von Ihnen einige personenbezogene Daten wie Name, Geschlecht, Telefonnummer und E-Mail-Adresse erfasst und von uns gespeichert. Diese Daten, ben&ouml;tigen wir zur Bereitstellung unseres Dienstes bzw zur Kontaktaufnahme mit Ihnen, um Ihnen den angeforderten Termin zu &uuml;bermitteln.
    br
    h1 Terminbuchung
    br
    | Um eine Terminbuchung abzuschlie&szlig;en, werden einige Informationen zur Abwicklung des Auftrags ben&ouml;tigt. Dabei wird grunds&auml;tzlich zwischen entsprechend gekennzeichneten Pflichtangaben und freiwillige Angaben unterschieden. Es handelt sich in der Regel um pers&ouml;nliche Informationen wie:
    br
    | Anrede
    br
    | Vorname und Nachname
    br
    | Geschlecht
    br
    | Telefonnummer
    br
    | E-Mail-Adresse
    br
    | Die Daten werden im Anschluss durch uns f&uuml;r die Erbringung der entsprechenden Dienstleistungen verwendet.
    br
    | Dazu z&auml;hlen:
    br
    | Verwendung Ihres Namens/Geschlecht zur eindeutigen Anrede und Identifikation.
    br
    | Verwendung Ihrer Kontaktdaten, um sie gegebenenfalls &uuml;ber wichtige Informationen wie Terminausfall durch Krankheit in Kenntnis zu setzen.
    br
    | Verwendung der Kontaktdaten zum Versenden von Best&auml;tigungsnachrichten oder Terminerinnerungen.
    br
    | Verwendung von vergangenen Termininformationen, um Ihnen einen bestm&ouml;glichen Service anbieten zu k&ouml;nnen.
    br
    | Die terminbezogenen Kundendaten werden von uns ausschlie&szlig;lich zur Erf&uuml;llung unserer Dienstleistung verwendet, von uns jedoch nicht anderweitig ausgewertet genutzt oder gar an Dritte &uuml;bermittelt.
    br
    h1 Kontaktformulare
    br
    | Die &uuml;ber unsere Kontaktformulare &uuml;bertragenen Daten werden ausnahmslos f&uuml;r die Bearbeitung Ihres Anliegens verwendet und von uns nicht zu weiteren Zwecken verarbeitet.
    br
    h1 Dritte
    br
    | Wir verwenden Google Fonts der Firma Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) auf unserer Webseite. Die Verwendung von Google Fonts erfolgt ohne Authentisierung und es werden keine Cookies an die Google Fonts API gesendet. Sollten Sie ein Konto bei Google haben, werden keine Ihrer Google-Kontodaten an Google w&auml;hrend der Nutzung von Google Fonts &uuml;bermittelt. Google erfasst lediglich die Nutzung von CSS und der verwendeten Fonts. Dabei ist es theoretisch m&ouml;glich &ndash; aktuell allerdings auch unklar ob und ggf. zu welchen Zwecken &ndash; dass Betreiber entsprechender Bibliotheken Daten erheben. Mehr zu diesen und weiteren Fragen finden Sie auf https://developers.google.com/fonts/faq.
    br
    | Welche Daten von Google erfasst werden und wof&uuml;r diese Daten verwendet werden, k&ouml;nnen Sie auf https://www.google.com/intl/de/policies/privacy nachlesen.
    br
    | Sicherheit und Schutz Ihrer personenbezogenen Daten
    br
    | Die bei uns &uuml;ber Sie gespeicherten personenbezogenen Daten werden mit &auml;u&szlig;erster Sorgfalt und entsprechend der DSGVO behandelt. Unser gesamtes Team ist zur Wahrung des Dienstgeheimnisses verpflichtet. Dar&uuml;ber hinaus sind Ihre pers&ouml;nlichen Daten durch zahlreiche technische und organisatorische Ma&szlig;nahmen in unserem deutschen Rechenzentrum vor unbefugtem Zugriff optimal gesch&uuml;tzt.
    br
    | Beim Besuch unserer Seite und der Nutzung unserer Dienste werden ausschlie&szlig;lich sichere und verschl&uuml;sselte SSL-Verbindungen verwendet, die es potentiellen Angreifern unm&ouml;glich machen sensible Daten&uuml;bertragungen abzufangen oder mitzulesen. Dass eine verschl&uuml;sselte Verbindung vorliegt erkennen Sie an der Internetadresse https:// und dem gr&uuml;nen Schloss in der Adresszeile Ihres Browsers.
    br
    | An dieser Stelle soll ausdr&uuml;cklich darauf hingewiesen werden, dass Sie selbst den gr&ouml;&szlig;ten Beitrag zum Schutz Ihrer pers&ouml;nlichen Daten leisten k&ouml;nnen, indem Sie einige Vorsichtsma&szlig;nahmen treffen. Neben dem Schutz Ihres Computers vor Viren und anderer Schadsoftware und der unbefugten Nutzung durch Dritte sollten Sie es sich zur Gewohnheit machen, Ihr pers&ouml;nliches Passwort regelm&auml;&szlig;ig abzu&auml;ndern und sicher zu gestalten. Ein Passwort ist dann als sicher einzustufen, wenn bestimmte Kriterien erf&uuml;llt sind. Ein sicheres Passwort sollte mindestens achtstellig sein und aus einer Kombination aus Ziffern, Klein- und Gro&szlig;buchstaben sowie Sonderzeichen bestehen. Bei der Vergabe eines Passwortes gibt es von uns keinerlei Vorgaben, allerdings empfehlen wir dringend ein solches sicheres Passwort zu verwenden, um Ihren Zugang bestm&ouml;glich zu sch&uuml;tzen.
    br
    | &Uuml;bermittlung Ihrer personenbezogenen Daten
    br
    | Die Erfassung personenbezogener Daten dient alleinig der Erf&uuml;llung des von Ihnen abgeschlossenen Vertrages. Die Nutzung und Verarbeitung dieser Daten erfolgt ausschlie&szlig;lich zur Erbringung unserer Dienstleistung Ihnen gegen&uuml;ber. Unsere IT-Dienstleister haben keinen Zugriff auf Ihre personenbezogenen Daten, da diese ausschlie&szlig;lich f&uuml;r die Bereitstellung der Infrastruktur zust&auml;ndig sind. F&uuml;r diese Dienstleistungen wurden die entsprechenden Anbieter sorgf&auml;ltig ausgew&auml;hlt und sind vertraglich zur Einhaltung des gesetzlichen Datenschutzes verpflichtet.
    br
    | Es erfolgt ausdr&uuml;cklich keine &Uuml;bermittlung oder &Uuml;berlassung Ihrer personenbezogenen Daten an Dritte.
    br
    br
    | Zur &Uuml;bermittlung des Termins an Sie nutzen wir folgende Dienste:
    br
    | Zum Empfang Ihrer Anfrage durch uns nutzen wir Telegram.
    br
    | <a target="_blank" href="https://telegram.org/privacy">telegram.org/privacy</a>
    br
    | Zur &Uuml;bersendung der Termin Nachricht an Sie nutzen wir Twilio.
    br
    | <a target="_blank" href="https://www.twilio.com/legal/privacy/authy">twilio.com/legal/privacy/authy</a>
    br
    | Zum Error-Tracking nutzen wir Sentry.
    br
    | <a target="_blank" href="https://sentry.io/privacy">sentry.io/privacy</a>
    br
    h1 L&ouml;schung Ihrer Daten
    br
    | Daten unserer registrierten Kunden werden von uns nur zur Vertragserf&uuml;llung gespeichert und aufbewahrt. Dar&uuml;ber hinaus m&uuml;ssen einige Ihrer Daten gem&auml;&szlig; gesetzlicher Aufbewahrungsfristen und &ndash;pflichten von uns verwahrt werden. Nach Fortfall der Notwendigkeit und Ablauf der genannten Fristen werden Ihre personenbezogenen Daten gem&auml;&szlig; den gesetzlichen Vorschriften gel&ouml;scht.
    br
    | Recht auf Auskunft, Berichtigung, Sperrung und L&ouml;schung
    br
    | Sie k&ouml;nnen jederzeit unentgeltliche Auskunft &uuml;ber Ihre, von uns gespeicherten, personenbezogenen Daten anfordern. Sie haben das Recht auf Berichtigung, Sperrung oder L&ouml;schung Ihrer Daten, insofern keine gesetzlichen Aufbewahrungsfristen oder sonstigen Regelungen entgegenstehen.
    br
    | Wenden Sie sich dazu bitte an db@eberswalde.fitness.
    br
    | &Auml;nderung unserer Datenschutzbestimmungen
    br
    | Durch ver&auml;nderte rechtliche Rahmenbedingungen oder Erweiterungen unseres Serviceangebots kann es notwendig werden, unsere Datenschutzbestimmungen anzupassen. Sollten wesentliche &Auml;nderungen vorgenommen werden, so informieren wir Sie in den Umst&auml;nden angemessener Form. Wenn Sie unsere Dienste im Rahmen der neuen Bestimmungen nicht weiter nutzen wollen, so haben Sie das Recht unseren Vereinbarungen zu widersprechen und durch eine Mitteilung an uns zu k&uuml;ndigen.
    br
    h1 Widerspruch und Widerruf
    br
    | Sie haben als betroffene Person jederzeit das Recht der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen, sofern keine gesetzlichen Vorgaben entgegenstehen. Ebenso kann eine erteilte Genehmigung zur Verarbeitung jederzeit formlos widerrufen werden. Wenden Sie sich dazu bitte an db@eberswalde.fitness.
    br
    | Fragen zum Datenschutz / Widerspruch
    br
    | Bei Fragen zu unseren Datenschutzbestimmungen oder der Nutzung Ihrer personenbezogenen Daten wenden Sie sich bitte an db@eberswalde.fitness.
  v-btn(@click="() => $router.back()" color="primary" x-large block).mb-2.mt-4 zurück

</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0
  },
}
</script>

<style lang="stylus" scoped>
h1
  margin-top: 16px
  margin-bottom: -24px

.overflownt
  overflow: hidden
</style>